export default __webpack_public_path__ + "static/media/click_purple_icon.ac339a5e.svg";